import { SelectionModel } from '@angular/cdk/collections';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { Router } from '@angular/router';
import { AbstractCrudComponent } from '../../component/abstract-crud.component';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { ErrorDialogComponent } from '../../dialogs/error-dialog/error-dialog.component';
import { AgendaMedicaDTO } from '../../dtos/agenda-medica-dto';
import { AgendaMedicaFiltroDTO } from '../../dtos/agenda-medica-filtro-dto';
import { Medico } from '../../medico/medico';
import { MedicoService } from '../../medico/medico.service';
import { ChaveValorNumberInterface } from '../../util/chave-valor-number-interface';
import { Util } from '../../util/util';
import { AgendaMedicaService } from '../agenda-medica.service';
import { AgendaMedicaPk } from '../pks/agenda-medica-pk';

@Component({
  selector: 'app-agenda-medica-list',
  templateUrl: './agenda-medica-list.component.html',
  styleUrls: ['./agenda-medica-list.component.css']
})
export class AgendaMedicaListComponent extends AbstractCrudComponent {

  displayedColumns: string[] = ['select', 'filial', 'diaSemana', 'horaAtendimento', 'quantidadeAtd',
    'atdIdadeMinima', 'atdIdadeMaxima', 'atdPortadorNecessidade', 'details'];

  formularioDeAgendaConsultaMedica: FormGroup;

  filtroAgendaMedica: AgendaMedicaFiltroDTO;

  listaDiasDaSemana: ChaveValorNumberInterface[] = Util.listaDiasDaSemana;

  public listaMedicos: Medico[] = [];

  selection: SelectionModel<any>;

  constructor(private agendaMedicaService: AgendaMedicaService, private medicoService: MedicoService,
    router: Router, dialog: MatDialog, private formBuilder: FormBuilder) {

    super(router, dialog);

    this.filtroAgendaMedica = history.state.filtroAgendaMedica;

    this.selection = new SelectionModel<any>(true, []);

    this.formularioDeAgendaConsultaMedica = this.formBuilder.group({
      medico: ['', [Validators.required]],
      diaSemana: [-1],
    });
  }

  ngOnInit() {

    super.ngOnInit();

    this.listarMedicos();
  }

  listarMedicos() {
    this.medicoService.listarComProjecao()
      .subscribe(data => {
        // console.log(data)
        this.listaMedicos = data;

        this.configurarForm();
      }, error => {
        console.log(error);
      });
  }

  configurarForm(): void {
    if (this.filtroAgendaMedica && this.filtroAgendaMedica.medico) {

      this.formularioDeAgendaConsultaMedica.setValue(this.filtroAgendaMedica);

      if (this.listaMedicos) {
        let currentMedico = this.listaMedicos.filter(medico => medico.id == this.filtroAgendaMedica.medico?.id)[0];
        this.formularioDeAgendaConsultaMedica.controls.medico.patchValue(currentMedico);
      }

      this.reloadData(this.filtroAgendaMedica);
    }
  }

  reloadData(filtro: AgendaMedicaFiltroDTO) {

    if (filtro.medico) {

      this.limparSelecao();

      let diaSemanaSelecionado: number = -1;
      if (filtro.diaSemana) {
        diaSemanaSelecionado = filtro.diaSemana;
      }

      this.agendaMedicaService.listarAgendaMedicaComProjecao(filtro.medico.id, diaSemanaSelecionado)
        .subscribe(data => {
          // console.log(data)


          const listaAgenda: Array<AgendaMedicaDTO> = [];

          data.forEach((element: any) => {
            listaAgenda.push(Object.assign(new AgendaMedicaDTO(), element));
          });

          this.data = listaAgenda;

          this.configurarDataSource();
        }, error => {
          console.log(error);
        });
    }
  }

  confirmDelete(id: AgendaMedicaPk) {
    const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirmação de exclusão',
        message: 'Deseja realmente remover essa informação ?'
      }
    });
    confirmDialog.afterClosed().subscribe(result => {
      if (result === true) {
        this.delete(id);
      }
    });
  }

  delete(id: AgendaMedicaPk) {
    this.agendaMedicaService.removerAgendaMedica(id)
      .subscribe(
        data => {
          // console.log(data);
          this.reloadData(this.filtroAgendaMedica);
        },
        error => {
          console.log(error);
        });
  }


  confirmDeleteLista() {
    if (this.selection.selected && this.selection.selected.length > 0) {
      const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          title: 'Confirmação de exclusão',
          message: 'Deseja realmente remover o(s) registro(s) selecionado(s) ?'
        }
      });
      confirmDialog.afterClosed().subscribe(result => {
        if (result === true) {
          this.deleteLista();
        }
      });
    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Selecione pelo menos uma agenda médica!'
        }
      });
    }
  }

  deleteLista() {

    this.agendaMedicaService.removerListaAgendaMedica(this.getListaDePksDaAgendaMedica())
      .subscribe(
        data => {
          // console.log(data);
          this.reloadData(this.filtroAgendaMedica);
        },
        error => {
          console.log(error);
        });
  }

  addNovoHorarioIndividual() {

    const filtroAgendaMedica: AgendaMedicaFiltroDTO = this.formularioDeAgendaConsultaMedica.value;

    this.router.navigate(['manterAgendaMedicaHorarioIndividual'], {
      state: {
        isUpdate: 'N',
        filtroAgendaMedica: filtroAgendaMedica,
      }
    });
  }

  addNovaAgenda() {
    const filtroAgendaMedica: AgendaMedicaFiltroDTO = this.formularioDeAgendaConsultaMedica.value;

    this.router.navigate(['manterAgendaMedica'], {
      state: {
        filtroAgendaMedica: filtroAgendaMedica,
      }
    });
  }

  details(id: AgendaMedicaPk) {

    const filtroAgendaMedica: AgendaMedicaFiltroDTO = this.formularioDeAgendaConsultaMedica.value;

    this.router.navigate(['manterAgendaMedicaHorarioIndividual'], {
      state: {
        id: id,
        isUpdate: 'N',
        filtroAgendaMedica: filtroAgendaMedica,
      }
    });
  }

  update(id: AgendaMedicaPk) {

    const filtroAgendaMedica: AgendaMedicaFiltroDTO = this.formularioDeAgendaConsultaMedica.value;

    this.router.navigate(['manterAgendaMedicaHorarioIndividual'], {
      state: {
        id: id,
        isUpdate: 'S',
        filtroAgendaMedica: filtroAgendaMedica,
      }
    });
  }


  getListaDePksDaAgendaMedica(): Array<AgendaMedicaPk> {

    const listaPks: Array<AgendaMedicaPk> = [];

    const listaAgendaMedica: any = this.selection.selected;

    if (listaAgendaMedica) {
      listaAgendaMedica.forEach((agenda: any) => {

        listaPks.push(agenda.pkAgendaMedica);

      });
    }

    return listaPks;
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  limparSelecao(): void {

    this.selection.clear()

  }

  limparTabela(): void {

    this.limparSelecao();

    this.data = [];

    this.configurarDataSource();
  }

  onChangeMedico(event: MatSelectChange): void {
    //this.limparTabela();

    this.consultar();
  }

  onChangeDiaSemana(event: MatSelectChange): void {
    //this.limparTabela();

    this.consultar();
  }

  consultar() {
    this.filtroAgendaMedica = this.formularioDeAgendaConsultaMedica.value;

    this.reloadData(this.filtroAgendaMedica);
  }

  temItemSelecionado(): boolean {

    return this.selection.selected && this.selection.selected.length > 0;

  }

}
